import React from 'react';
import { IonGrid, IonRow, IonCol, IonButton, IonIcon, IonLabel} from '@ionic/react';
import { RouteComponentProps } from 'react-router-dom';
import './HeaderApp.css';
import { chevronBackOutline } from 'ionicons/icons';
import { isPlatform } from '@ionic/react';

interface HeaderSimpleProps extends RouteComponentProps {
  headerTitle: string;
}

const HeaderSimple: React.FC<HeaderSimpleProps> = ({history, headerTitle, match, location}) => {
  return (
        <IonGrid className={isPlatform('ios') ? "my-toolbar-ios" : "my-toolbar"}>
        <IonRow>
            <IonCol size="1" className="ion-align-self-left">
                <IonButton mode="ios" size="small" fill="clear" className="my-back-button" color="primary-contrast" 
                          onClick = {() => {history.goBack()}}>
                  <IonIcon mode="ios" icon={chevronBackOutline} color="primary-contrast"/>
                </IonButton>
            </IonCol>
            <IonCol size="5" className="ion-align-self-center"> 
              <IonLabel mode="ios" className="my-label-title">{headerTitle}</IonLabel>
            </IonCol>
            <IonCol size="6"></IonCol>
          </IonRow>        
        </IonGrid>
  );
};

export default HeaderSimple;
